
import React from 'react';

interface LevelProgressBarProps {
  currentLevelIndex: number;
  totalLevels: number;
}

const LevelProgressBar = ({ currentLevelIndex, totalLevels }: LevelProgressBarProps) => {
  return (
    <div className="w-full">
      <div className="w-full bg-muted/50 h-2 rounded-full mt-4 mb-1 overflow-hidden">
        <div 
          className="h-full bg-primary rounded-full transition-all duration-1000" 
          style={{ width: `${((currentLevelIndex + 1) / totalLevels) * 100}%` }}
        ></div>
      </div>
      <p className="text-xs text-muted-foreground">
        {currentLevelIndex + 1} of {totalLevels} levels complete
      </p>
    </div>
  );
};

export default LevelProgressBar;
